import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";

export const ProductCard = ({ product, index = 0 }) => (
  <Link
    to={`/products/${product.id}`}
    data-testid={`product-card-${product.id}`}
    className="group block fade-up"
    style={{ animationDelay: `${index * 0.05}s` }}
  >
    <div className="relative aspect-[3/4] overflow-hidden rounded-sm bg-[#141417] border border-white/5 group-hover:border-[#D4AF37]/40 transition-all duration-500">
      <img
        src={mediaUrl(product.hero_thumbnail)}
        alt={product.title}
        className="absolute inset-0 w-full h-full object-cover img-zoom"
      />
      {product.color && (
        <span className="absolute top-3 left-3 text-[10px] font-mono uppercase tracking-[0.15em] px-2 py-1 rounded-full bg-black/50 backdrop-blur border border-white/15">
          {product.color}
        </span>
      )}
    </div>
    <div className="mt-4">
      <p className="overline" data-testid={`product-brand-${product.id}`}>{product.brand || product.product_type}</p>
      <h3 className="font-serif text-xl font-light mt-1 group-hover:text-[#D4AF37] transition-colors duration-300">
        {product.title}
      </h3>
      <div className="flex items-center justify-between mt-1">
        <p className="text-[#8E8E9A] text-xs font-light">
          {[product.product_type, product.fabric].filter(Boolean).join(" · ")}
        </p>
        {product.price && (
          <span className="text-[#D4AF37] text-xs font-mono" data-testid={`product-price-${product.id}`}>
            {Math.round(parseFloat(product.price))}
          </span>
        )}
      </div>
    </div>
  </Link>
);
